import { gql } from '@/__generated__';

export const UPDATE_OPERATIONAL_STATE = gql(`#graphql
  mutation UpdateOperationalState($deviceId: ID!, $operationalState: DeviceOperationalState!) {
    updateDevice(deviceId: $deviceId, input: { operationalState: $operationalState }) {
      id
      profile {
        id
        name
        operationalState
      }
    }
  }
`);
